import { createContext } from 'react'
import type { NavigateFunction } from 'react-router-dom'

export const StableNavigateContext = createContext<React.MutableRefObject<NavigateFunction> | null>(null)
